if (!customElements.get('shop-all-filters')) {
  customElements.define(
    'shop-all-filters',
    class ShopAllFilters extends HTMLElement {
      constructor() {
        super();
        this.storageKey = 'shopAllFilter';
        this.items = Array.from(this.querySelectorAll('.shop-all__item'));
        this.pills = Array.from(this.querySelectorAll('.shop-all__pill'));
        this.countEl = this.querySelector('[data-shop-all-count]');
        this.emptyEl = this.querySelector('[data-shop-all-empty]');

        this.pills.forEach((pill) => {
          pill.addEventListener('click', () => this.applyFilter(pill.dataset.filter));
        });

        // Sorting reloads the page (native Shopify sort_by), which would
        // otherwise reset the filter back to "All" — remember the last
        // choice across that reload instead.
        const saved = sessionStorage.getItem(this.storageKey);
        this.applyFilter(saved || 'all');
      }

      applyFilter(filter) {
        sessionStorage.setItem(this.storageKey, filter);

        this.pills.forEach((pill) => {
          pill.classList.toggle('shop-all__pill--active', pill.dataset.filter === filter);
        });

        // Lifts the mobile "preview" 6-item cap (see section-shop-all.css)
        // once an actual filter is picked — only the untouched "All" view
        // stays capped.
        this.classList.toggle('shop-all--filtered', filter !== 'all');

        let visibleCount = 0;
        this.items.forEach((item) => {
          const matches =
            filter === 'all' ||
            (filter === 'sale' ? item.dataset.onSale === 'true' : item.dataset.capType === filter);
          item.hidden = !matches;
          if (matches) visibleCount += 1;
        });

        if (this.countEl) this.countEl.textContent = visibleCount;
        if (this.emptyEl) this.emptyEl.hidden = visibleCount !== 0;
      }
    }
  );
}
